// src/components/MobileNavbar.jsx
import { Link, NavLink } from "react-router-dom";
import { palette } from "../pages/theme";
import logo from "../assets/Logo.png";

export default function MobileNavbar({ onOpenSidebar }) {
  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 md:hidden shadow-lg"
      style={{
        backgroundColor: "#0A1A44",
        borderColor: palette.railLine,
        backdropFilter: "blur(6px)",
      }}
    >
      <div className="flex items-center justify-between px-4 py-3">
        {/* LEFT SECTION: Info button + logo */}
        <div className="flex items-center gap-3">
          {onOpenSidebar && (
            <button
              type="button"
              onClick={onOpenSidebar}
              className="inline-flex items-center justify-center rounded-full px-3 py-1 text-xs border text-white"
              style={{
                borderColor: "#C0A87B",
                backgroundColor: "rgba(255,255,255,0.15)",
              }}
            >
              ☰ Info
            </button>
          )}

          <Link to="/" className="flex items-center">
            <img
              src={logo}
              alt="Carnatic Cafe"
              className="h-12 w-auto object-contain"
            />
          </Link>
        </div>

        {/* RIGHT SECTION: NAV LINKS */}
        <nav
          className="
            flex items-center gap-4 text-sm font-medium text-white
            flex-nowrap overflow-x-auto no-scrollbar px-2 scroll-pl-3 scroll-pr-6
            md:flex-wrap md:overflow-visible
          "
          style={{ WebkitOverflowScrolling: "touch" }}
        >
          <NavLink
            to="/"
            className={({ isActive }) =>
              isActive ? "text-yellow-400" : "hover:text-[#FFD580]"
            }
          >
            Home
          </NavLink>

          <NavLink
            to="/menu"
            className={({ isActive }) =>
              isActive ? "text-yellow-400" : "hover:text-[#C69A35]"
            }
          >
            Menu
          </NavLink>

          <NavLink
            to="/tiffin"
            className={({ isActive }) =>
              isActive ? "text-yellow-400" : "hover:text-[#FFF1DD]"
            }
          >
            Tiffin
          </NavLink>

          <NavLink
            to="/catering"
            className={({ isActive }) =>
              isActive ? "text-yellow-400" : "hover:text-[#FFF1DD]"
            }
          >
            Catering
          </NavLink>

          <NavLink
            to="/gallery"
            className={({ isActive }) =>
              isActive ? "text-yellow-400" : "hover:text-[#FFF1DD]"
            }
          >
            Gallery
          </NavLink>

          <NavLink
            to="/contact"
            className={({ isActive }) =>
              isActive ? "text-yellow-400" : "hover:text-[#FFF1DD]"
            }
          >
            Contact
          </NavLink>

          <NavLink
            to="/about"
            className={({ isActive }) =>
              isActive ? "text-yellow-400" : "hover:text-[#FFF1DD]"
            }
          >
            About
          </NavLink>
        </nav>
      </div>
    </header>
  );
}
